import mutations from './accKeySummaryMutation';
import actions from './accKeySummaryAction';
import getters from './accKeySummaryGetter';

const state = {
  weekChanges: [],
  lastSummary: [],
  exceptKeys: {},
  d1Cnt: 0,
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/summary/accKeySummaryStore.js